var _ellipse, _ellipse2, _ellipse3, _ellipse4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTestimonialBubbleIcon = function SvgTestimonialBubbleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 150,
    viewBox: "0 0 177 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.612,
    cy: 39.763,
    rx: 30.039,
    ry: 29.476,
    transform: "rotate(138.716 87.612 39.763)",
    fill: "#007B82",
    fillOpacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.38,
    cy: 102.767,
    rx: 16.986,
    ry: 16.513,
    transform: "rotate(138.716 120.38 102.767)",
    fill: "#00D984",
    fillOpacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.468,
    cy: 122.087,
    rx: 20.983,
    ry: 20.517,
    transform: "rotate(138.716 53.468 122.087)",
    fill: "#102B3F",
    fillOpacity: 0.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.155,
    cy: 62.679,
    rx: 13.865,
    ry: 13.532,
    transform: "rotate(138.716 19.155 62.679)",
    fill: "#102B3F",
    fillOpacity: 0.2
  })));
};

export default SvgTestimonialBubbleIcon;